// extracted by mini-css-extract-plugin
export default {"container-funded":"ABSSZ","breakline":"tT2bp","timer":"YvKIU"};